<template>
  <div id="relative-off-def-efficiency-containier" class="border-padding">
  <main>
    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>
    <p>Points per 100 possessions better/worse than league average for season</p>
    <div v-if="table_data.length > 0" class="col-md-5">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: true}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'season', type: 'desc'}}"
            :line-numbers="true"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div>
                <span>
                  <b>{{props.formattedRow[props.column.field]}}</b>
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import { tableUtils } from './mixins/table_utils'

export default {
  name: 'RelativeOffDefRtg',
  mixins: [tableUtils],
  data () {
    return {
      loading: false,
      table_data: [],
      table_columns: [
        {'field': 'season', 'label': 'Season'},
        {'field': 'team', 'label': 'Team', 'filterable': true},
        {'field': 'rel_ortg', 'label': 'Relative Offensive Efficiency', 'type': 'decimal'},
        {'field': 'rel_drtg', 'label': 'Relative Defensive Efficiency', 'type': 'decimal'}
      ],
      show_error_message: false,
      api_endpoint: 'get-relative-off-def-efficiency/'
    }
  },
  created () {
    this.getStats()
  },
  watch: {
    '$route': 'getStats',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.table_data = []
      this.$router.push({name: 'relative_off_def_rtg', params: {league: this.$parent.league}})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []

      this.loading = true
      axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {})
        .then((response) => {
          if (!response.data.error) {
            this.table_data = response.data.results
          } else {
            this.show_error_message = true
          }
          this.loading = false
        }, (error) => {
          this.show_error_message = true
          this.loading = false
          this.error = error
        })
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/RelativeOffDefRtg.vue